var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSnsYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6927 23.76C24.1222 23.7067 25.0586 23.7067 25.9004 22.8C26.5619 22.1067 26.7766 20.5422 26.7766 20.5422C26.7766 20.5422 27 18.7022 27 16.8622V15.1289C27 13.2889 26.7766 11.4489 26.7766 11.4489C26.7766 11.4489 26.5619 9.88444 25.9004 9.19111C25.0672 8.28444 24.1308 8.28444 23.6927 8.23111C20.6603 8.00889 16.1417 8 16.0043 8H15.9957C15.8583 8 11.3311 8 8.3073 8.23111C7.87778 8.28444 6.94143 8.28444 6.09957 9.19111C5.43811 9.87556 5.22335 11.4489 5.22335 11.4489C5.22335 11.4489 5.01718 13.1378 5 14.8978V17.0933C5.01718 18.8533 5.21476 20.5422 5.21476 20.5422C5.21476 20.5422 5.42952 22.1067 6.09098 22.8C6.92425 23.7067 8.02382 23.68 8.51347 23.7689C10.1199 23.9289 15.0078 23.9911 15.8583 24H16.305C17.3959 23.9911 21.0984 23.9556 23.6927 23.76ZM19.6638 15.76L13.7192 18.9422V12.5511L19.6638 15.76Z",
    fill: "#CDD6E3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsYoutube);
export default __webpack_public_path__ + "static/media/sns_youtube.1c6fd4330bcbb2ec95abd6df23ba5487.svg";
export { ForwardRef as ReactComponent };